module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comment",
      toString: function () {
        return this.url;
      }
    }